/*  ==========================================================================
    USER SESSION RECOGNITION
    ========================================================================== */

// local imports

/* CODE
 * --------------------------------------------------------------------------- */

let userKnownStatus = false;
const userKnownStatusSessionStorageKey = 'DNA[user-session-recognition]';

/**
 * set known status in session storage
 */
function setUserAsKnownInSessionStorage() {
    sessionStorage.setItem(userKnownStatusSessionStorageKey, '1');
}

/**
 * get known status from session storage
 * @return {null|string}
 */
function getUserKnownStatusFromSessionStorage(defaultValue = '0') {
    return sessionStorage.getItem(userKnownStatusSessionStorageKey) || defaultValue;
}

/**
 * Return the current known status of the user
 * @return {boolean}
 */
export function isUserKnownInThisSession() {
    return userKnownStatus;
}

/**
 * initialize UserRecognition
 */
export function initUserRecognition() {
    userKnownStatus = (getUserKnownStatusFromSessionStorage() === '1');
    if (userKnownStatus) {
        console.log('USER-RECOGNITION', 'user was recognised from session');
    } else {
        console.log('USER-RECOGNITION', 'user was NOT recognised from session');
    }
    setUserAsKnownInSessionStorage();
}


// WEBPACK FOOTER //
// ./source/js/utilities/user-session-recognition.js